import { changeProgramCampusModalityRequest as schemaChangeProgramCampusModality } from './schemas';
import apiClient from './apiClient';
import ChangeProgramCampusModalityDataStore from '../../datastores/ChangeProgramCampusModalityDataStore';

class ChangeProgramCampusModalityDataStoreMock
  implements ChangeProgramCampusModalityDataStore
{
  client = apiClient();

  async registerChangeAcademicData(
    procedureId: number,
    modality: any,
    campus: any,
    program: any,
    files: any
  ) {
    try {
      const registerChangeAcademicData = {
        procedureId,
        modality,
        campus,
        program,
        files
      };
      const response = await this.client.mutate({
        mutation: schemaChangeProgramCampusModality.registerChangeAcademicData,
        variables: { registerChangeAcademicData }
      });
      const { data } = response;
      return data?.registerChangeAcademicData;
    } catch (error) {
      throw new Error('error register change photo');
    }
  }

  async activateChangeAcademicData(
    requestId: number,
    procedureId: number,
    campus: string,
    career: string
  ) {
    try {
      const response = await this.client.mutate({
        mutation: schemaChangeProgramCampusModality.activateChangeAcademicData,
        variables: { requestId, procedureId, campus, career }
      });
      const { data } = response;
      return data?.activateChangeAcademicData;
    } catch (error) {
      throw new Error('error cancel change photo');
    }
  }

  async cancel(requestId: number, procedureId: number) {
    try {
      const response = await this.client.mutate({
        mutation: schemaChangeProgramCampusModality.cancelChangeAcademicData,
        variables: { requestId, procedureId }
      });
      const { data } = response;
      return data?.cancelRequestChangeAcademicData;
    } catch (error) {
      throw new Error('error cancel change program campus modality');
    }
  }
}

export default ChangeProgramCampusModalityDataStoreMock;
